<div class="full-calendar-container">
  <full-calendar #calendarRef [options]="calendarOptions"></full-calendar>
</div>
